module.exports = __webpack_public_path__ + "img/make-it_mobile.8c08779.jpg";